import {PauseIcon, PlayIcon} from './Icons'

import Styles from './AutoPlayVideo.module.css'

export interface AutoPlayVideoButtonProps {
  /** When `true` the button shows the play icon (the video is paused or has ended). */
  pressed: boolean
  /** Label announced to assistive technology, describing the current action. */
  label: string
  /** Accessible label for the button. */
  ariaLabel: string
  onClick: () => void
  /** Analytics data attributes to spread onto the button. */
  analyticsAttributes?: Record<string, unknown>
  /** Class applied to the button. */
  className?: string
  /** Class applied to the play/pause icon. */
  iconClassName?: string
}

export function AutoPlayVideoButton({
  pressed,
  label,
  ariaLabel,
  onClick,
  analyticsAttributes,
  className,
  iconClassName,
}: AutoPlayVideoButtonProps) {
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-pressed={pressed}
      aria-label={ariaLabel}
      {...analyticsAttributes}
    >
      {pressed ? <PlayIcon className={iconClassName} /> : <PauseIcon className={iconClassName} />}
      <span className={Styles['VisuallyHidden']}>{label}</span>
    </button>
  )
}
